import { RETRIEVE_QUOTE_ENABLED } from "./config"

const COOKIE_KEY = "dalma_quote_health_de"

const MAX_AGE = 7776000 // 90 days in seconds

function buildCookie(value: string, maxAge: number) {
  const hostname = window.location.hostname
  const isSecure = window.location.protocol === "https:"

  let domain = ""
  if (hostname.endsWith(".dalma.co")) domain = ".dalma.co"
  else if (hostname.endsWith(".dalma.dev")) domain = ".dalma.dev"

  let cookie = `${COOKIE_KEY}=${value}; path=/; max-age=${maxAge}; samesite=lax`
  if (domain) cookie += `; domain=${domain}`
  if (isSecure) cookie += `; secure`
  return cookie
}

export function saveQuoteIdCookie(quoteId: string) {
  if (!RETRIEVE_QUOTE_ENABLED) return
  if (!quoteId) return
  document.cookie = buildCookie(quoteId, MAX_AGE)
}

export function getQuoteIdFromCookie(): string | null {
  if (!RETRIEVE_QUOTE_ENABLED) return null
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_KEY}=([^;]*)`))
  return match ? match[1] : null
}

export function deleteQuoteIdCookie() {
  document.cookie = buildCookie("", 0)
}
